<template>
	<div id="home">
		<div class="home-top">
			<div class="header">
				<div class="logo">
					<img v-if="shebeiLogin == 1" src="./../../assets/shebei.jpg" alt="" />
					<img v-else-if="simInfo.flowRatePool == '联通' || simInfo.flowRatePool == '乐语'"
						src="./../../assets/cucc.png" alt="" />
					<img v-else-if="simInfo.flowRatePool == '电信'" src="./../../assets/ctcc.png" alt="" />
					<img v-else-if="simInfo.flowRatePool == '移动' || simInfo.flowRatePool == '移动接口'"
						src="./../../assets/cmcc.png" alt="" />
					<img v-else :src="wxHeadImg" alt="" />
				</div>
				<div class="header-userInfo">
					<!-- <p v-show="leshuaPay!=1">{{ wxNickName }}</p> -->
					<div class="iccid-line">{{ this.$store.state.recordLoginText }}</div>
					<div class="el-status phone-bg" v-if="simInfo.isVoice === 1">
						{{ simInfo.virtualNo }}
					</div>
					<div class="el-status card-bg">{{ simInfo.cardStateName }}</div>
					<div class="el-status auth-bg">{{ isAuthName }}</div>
					<!-- <p v-if="simInfo.alias">{{simInfo.supplierTypeName}} - {{simInfo.alias}} 通道</p>
					<p v-else>{{simInfo.supplierTypeName}}</p> -->
				</div>
				<div class="refresh">
					<keep-alive>
						<SuspendButton @suspendFn="updateStateRateFlow" />
					</keep-alive>
					<keep-alive> 刷新 </keep-alive>
				</div>
			</div>
			<!-- <div class="flowInfo">
				<van-circle :value="wxCircle" text="剩余流量" layer-color="#78D2D7" :stroke-width="50" size="140" :clockwise="false" color="#fff" />
				<div class="residue-flow">
					<p style="font-size:1.1rem;position: absolute;left: 0;right: 0;text-align: center;top:20%">{{fluxMtoG(simInfo.flowRate - simInfo.usedFlowRate)}}G</p> 
				</div>
				<div class="flowInfo-bottom">
					<div class="total-flow">
						<p style="color: #C4E9EB;font-size:0.875rem;padding-bottom:0.875rem;">总流量/GB</p>
						<p style="font-size:1rem">{{fluxMtoG(simInfo.flowRate)}}</p>
					</div>
					<div class="used-flow">
						<p style="color:#C4E9EB;font-size:0.875rem;padding-bottom:0.875rem;">已使用/GB</p>
						<p style="font-size:1rem">{{fluxMtoG(simInfo.usedFlowRate)}}</p>
					</div>
				</div>
			</div> -->
			<div class="el-vant-status">
				<div class="sdaf" v-if="simInfo.isVoice === 1">
					<div class="flow-btn" @click="btnChange('1')" :class="{ active: btnIndex === '1' }">
						<div />
						<span>流量</span>
					</div>
					<div class="flow-btn" @click="btnChange('2')" :class="{ active1: btnIndex === '2' }">
						<div />
						<span>语音时长</span>
					</div>
				</div>
				<div class="sdaf" v-if="simInfo.isVoice === 0">
					<div class="flow-btn" @click="btnChange('1')" :class="{ active: btnIndex === '1' }">
						<div />
						<span>本月流量</span>
					</div>
					<div class="flow-btn" @click="btnChange('3')" :class="{ active1: btnIndex === '3' }">
						<div />
						<span>次月流量</span>
					</div>
				</div>

				<div class="flow" style="padding: 14px" v-if="btnIndex === '1'">
					<div @click="pkgListVisible = true">
						<div class="status-info">
							<div class="status-info-left">
								<p v-if="simInfo.alias">{{ simInfo.alias }} 通道</p>
								<p v-else>{{ simInfo.supplierTypeName }}</p>
							</div>
							<div class="status-info-right">
								过期时间：{{ simInfo.endTime }}
							</div>
						</div>
						<van-progress color="#2452C8" :percentage="wxCircle" :stroke-width="8" :show-pivot="false" />
						<!-- <van-circle :value="wxCircle" text="剩余流量" layer-color="#78D2D7" :stroke-width="50" size="140" :clockwise="false" color="#fff" /> -->
						<div class="flowInfo">
							<div class="flowInfo_left" style="text-align: left">
								<div class="flowInfo_content">
									{{ fluxMtoG(simInfo.flowRate) }}G
								</div>
								<div class="flowInfo_1" style="padding-left: 0.5rem">
									总流量
								</div>
							</div>
							<div class="flowInfo_left">
								<div class="flowInfo_content">
									{{ fluxMtoG(simInfo.usedFlowRate) }}G
								</div>
								<div class="flowInfo_1">已用流量</div>
							</div>
							<div class="flowInfo_left" style="text-align: right">
								<div class="flowInfo_content">
									{{ fluxMtoG(simInfo.flowRate - simInfo.usedFlowRate) }}G
								</div>
								<div class="flowInfo_1" style="padding-right: 0.5rem">
									剩余流量
								</div>
							</div>
						</div>
						<div class="userPice">
							<div class="userAccount">账户余额</div>
							<div class="userMoney">
								￥{{ money_format(userAccount.amount / 100, 2, ".", ",") }}
							</div>
						</div>
						<div class="userPice" style="margin-top: 0;" v-if="isMyLogin">
							<div class="userAccount">活动余额</div>
							<div class="userMoney">
								￥{{ money_format(simInfo.userPriceAmount, 2, ".", ",") }}
							</div>
						</div>
					</div>
				</div>

				<div class="flow" style="padding: 14px" v-if="btnIndex === '3'">
					<div @click="pkgListVisible = true">
						<div class="status-info">
							<div class="status-info-left">
								<p v-if="simInfo.alias">{{ simInfo.alias }} 通道</p>
								<p v-else>{{ simInfo.supplierTypeName }}</p>
							</div>
							<div class="status-info-right">
								过期时间：{{ simInfo.noEndTime }}
							</div>
						</div>
						<van-progress color="#2452C8" :percentage="wxCircle" :stroke-width="8" :show-pivot="false" />
						<!-- <van-circle :value="wxCircle" text="剩余流量" layer-color="#78D2D7" :stroke-width="50" size="140" :clockwise="false" color="#fff" /> -->
						<div class="flowInfo">
							<div class="flowInfo_left" style="text-align: left">
								<div class="flowInfo_content">
									{{ fluxMtoG(simInfo.noTotalData) }}G
								</div>
								<div class="flowInfo_1" style="padding-left: 0.5rem">
									总流量
								</div>
							</div>
							<div class="flowInfo_left">
								<div class="flowInfo_content">
									{{ fluxMtoG(simInfo.noUseData) }}G
								</div>
								<div class="flowInfo_1">已用流量</div>
							</div>
							<div class="flowInfo_left" style="text-align: right">
								<div class="flowInfo_content">
									{{ fluxMtoG(simInfo.noTotalData - simInfo.noUseData) }}G
								</div>
								<div class="flowInfo_1" style="padding-right: 0.5rem">
									剩余流量
								</div>
							</div>
						</div>
						<div class="userPice">
							<div class="userAccount">账户余额</div>
							<div class="userMoney">
								￥{{ money_format(userAccount.amount / 100, 2, ".", ",") }}
							</div>
						</div>
						<div class="userPice" style="margin-top: 0;" v-if="isMyLogin">
							<div class="userAccount">活动余额</div>
							<div class="userMoney">
								￥{{ money_format(simInfo.userPriceAmount, 2, ".", ",") }}
							</div>
						</div>
					</div>
				</div>
				<div class="flow" style="padding: 14px" v-if="btnIndex === '2'">
					<div @click="pkgListVisible = true">
						<div class="status-info">
							<div class="status-info-left">
								<p v-if="simInfo.alias">{{ simInfo.alias }} 通道</p>
								<p v-else>{{ simInfo.supplierTypeName }}</p>
							</div>
							<div class="status-info-right">
								过期时间：{{ simInfo.endTime }}
							</div>
						</div>
						<van-progress color="#2452C8" :percentage="wxCircle" :stroke-width="8" :show-pivot="false" />
						<!-- <van-circle :value="wxCircle" text="剩余流量" layer-color="#78D2D7" :stroke-width="50" size="140" :clockwise="false" color="#fff" /> -->
						<div class="flowInfo">
							<div class="flowInfo_left" style="text-align: left">
								<div class="flowInfo_content">
									{{ simInfo.remainVoice }}分钟
								</div>
								<div class="flowInfo_1" style="padding-left: 0.5rem">
									剩余通话数
								</div>
							</div>
							<div class="flowInfo_left">
								<div class="flowInfo_content">{{ simInfo.useVoice }}分钟</div>
								<div class="flowInfo_1">已用通话数</div>
							</div>
							<div class="flowInfo_left" style="text-align: right">
								<div class="flowInfo_content">{{ simInfo.totalVoice }}分钟</div>
								<div class="flowInfo_1" style="padding-right: 0.5rem">
									总通话数
								</div>
							</div>
						</div>
						<div class="userPice">
							<div class="userAccount">账户余额</div>
							<div class="userMoney">
								￥{{ money_format(simInfo.amount / 100, 2, ".", ",") }}
							</div>
						</div>
						<div class="userPice" style="margin-top: 0;" v-if="isMyLogin">
							<div class="userAccount">活动余额</div>
							<div class="userMoney">
								￥{{ money_format(simInfo.userPriceAmount, 2, ".", ",") }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 卡片管理 -->
		<van-popup v-model="showIccidList" closeable position="top" style="min-height: 20%; max-height: 50%">
			<div class="iccid-list">
				<h1>卡片管理</h1>
				<div class="iccid-list-item" v-for="item in iccidList" :key="item.iccid">
					<p v-if="item.simDefault == 0">{{ item.iccid }}</p>
					<p v-else-if="item.simDefault == 1" style="color: #ffa941">
						{{ item.iccid }}
					</p>
					<button v-if="item.simDefault == 0" @click="updateDefaultBindIccidHandler(item.iccid)">
						设为默认
					</button>
					<button class="delete-item" @click="deleteBindIccidHandler(item.iccid)">
						删除
					</button>
				</div>
			</div>
		</van-popup>
		<div class="main">
			<div class="">
				<van-notice-bar v-if="isMyLogin" color="#848484" background="#F9F9F9" left-icon="volume-o"
					:text="notifyContent" :style="{
						borderRadius: '10px',
						width: '94%',
						padding: '6',
						margin: '10px auto 20px auto',
					}" mode="link" class="vant-notice" @click="toMoreNotify()"></van-notice-bar>
			</div>
			<div class="content-bottom">
				<div class="main-bottom">
					<!--  总部微信公众号   -->
					<div v-if="$store.state.isHeadquarterAppid == 'true'">
						<div v-if="(yucun == 1 || yucun == 888) && isMyLogin">
							<a href="javascript: void(0);" @click="toBalanceRecharge1()">
								<img src="@/assets/home/icon03.png" alt="" />
								<div class="shadow"></div>
								<span>余额充值</span>
							</a>
						</div>
						<div v-if="isMyLogin">
							<a href="javascript: void(0);" @click="toBalanceRecharge()">
								<img src="@/assets/home/icon03.png" alt="" />
								<div class="shadow"></div>
								<span>余额充值</span>
							</a>
						</div>
						<div>
							<a href="javascript: void(0);" @click="toRecharge()">
								<img src="@/assets/home/icon04.png" alt="" />
								<div class="shadow"></div>
								<span>套餐订购</span>
							</a>
						</div>
						<div>
							<a href="javascript: void(0);" @click="toRecharge12()">
								<img src="@/assets/home/icon05.png" alt="">
								<div class="shadow"></div>
								<span>自动续费</span>
							</a>
						</div>
						<div>
							<a href="javascript: void(0);" @click="toRecharge1()">
								<img src="@/assets/home/icon06.png" alt="" />
								<div class="shadow"></div>
								<span>智能复机</span>
							</a>
						</div>
						<div v-if="isAgentLogin != 1 && isMyLogin">
							<a href="javascript:void(0)" @click="buyCard()">
								<img src="@/assets/home/icon07.png" alt="" />
								<div class="shadow"></div>
								<span>在线购买</span>
							</a>
						</div>

						<!-- <div>
							<a href="javascript: void(0);" @click="pkgListVisible = true">
								<img src="@/assets/home/icon08.png" alt="">
								<div class="shadow"></div>
								<span>可用套餐</span>
							</a>
						</div> -->
						<div>
							<a href="javascript: void(0);" @click="pkgListVisible1 = true">
								<img src="@/assets/home/icon09.png" alt="" />
								<div class="shadow"></div>
								<span>次月套餐</span>
							</a>
						</div>
						<div v-if="cuccAuthShow">
							<a href="javascript:void(0)" @click="cuccAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="cmccXxtx">
							<a href="javascript:void(0)" @click="cmccXxtxmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="ctccOldAuth">
							<a href="javascript:void(0)" @click="toCtccoldAth()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="ctccAuthShow">
							<a href="javascript:void(0)" @click="ctccAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="guangdianAuth">
							<a href="javascript:void(0)" @click="toGaungdianAuth()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="jiaAuth">
							<a href="javascript:void(0)" @click="toJiaAuth()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="otherAuth">
							<a href="javascript:void(0)" @click="otherAuthM()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="cmccAuthShow">
							<a href="javascript:void(0)" @click="cmccAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="qianhaiSHow">
							<a :href="qianhaiUrls">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="leyuAuthShow">
							<a href="javascript:void(0)" @click="leyuAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else>
							<a
								:href="`#/user/verified?state=${state}&supplierTypeCode=${simInfo.supplierTypeCode}&realNameCard=${simInfo.realNameCard}`">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>

						<div>
							<a href="javascript: void(0);" @click="analysisHandler()">
								<img src="@/assets/home/icon10.png" alt="" />
								<div class="shadow"></div>
								<span>刷新复机</span>
							</a>
						</div>

						<div>
							<a href="#/user/balanceRechargeRecord">
								<img src="@/assets/home/icon11.png" alt="" />
								<div class="shadow"></div>
								<span>充值记录</span>
							</a>
						</div>

						<!-- <div v-show="isSHowShop=='0'">
                <a href="javascript:void(0)" @click="buyCard1()">
                  <img src="@/assets/home/icon07.png" alt="">
                  <div class="shadow"></div>
                  <span>在线商城</span>
                </a>
              </div> -->

						<div v-if="canChangeCard">
							<a href="javascript:void(0)" @click="toChgCardQuery()">
								<img src="@/assets/home/15.png" alt="" />
								<div class="shadow"></div>
								<span>换卡申请</span>
							</a>
						</div>

						<div v-if="alreadyHasAccount && shebeiLogin != 1">
							<a href="javascript: void(0);" @click="showPasswordPanel = true">
								<img src="@/assets/home/icon12.png" alt="" />
								<div class="shadow"></div>
								<span>修改密码</span>
							</a>
						</div>

						<div v-if="simInfo.supplierCode == '1255311826602684416'">
							<a href="javascript: void(0);" @click="reBind()">
								<img src="@/assets/home/icon13.png" alt="" />
								<div class="shadow"></div>
								<span>机卡重绑</span>
							</a>
						</div>
						<div v-if="kefuUrl">
							<a href="javascript: void(0);" @click="toKefu()">
								<img src="@/assets/home/user.png" alt="" />
								<div class="shadow"></div>
								<span>在线客服</span>
							</a>
						</div>

						<div v-if="isSale > 0 && shebeiLogin != 1" @click="toApplyShops()">
							<a href="javascript: void(0);">
								<img src="@/assets/home/28.png" alt="" />
								<div class="shadow"></div>
								<span>赠送金</span>
							</a>
						</div>

						<div @click="bindList()" v-if="shebeiLogin != 1 && isMyLogin">
							<a href="javascript: void(0);">
								<img src="@/assets/home/24.png" alt="" />
								<div class="shadow"></div>
								<span>手机绑定</span>
							</a>
						</div>
						<div v-if="(yucun == 3 || yucun == 8888) && shebeiLogin != 1">
							<a :href="`#/user/huodong2`">
								<img src="@/assets/home/20.png" alt="" />
								<div class="shadow"></div>
								<span>叠加券活动</span>
							</a>
						</div>
						<div v-if="isMyLogin">
							<a href="javascript:void(0)" @click="submitFeedback()">
								<img src="@/assets/user/31.png" alt="" />
								<div class="shadow"></div>
								<span>投诉商家</span>
							</a>
						</div>
					</div>

					<!--  代理商端  -->
					<div v-else>
						<div>
							<a href="javascript: void(0);" @click="toRecharge()">
								<img src="@/assets/home/icon04.png" alt="" />
								<div class="shadow"></div>
								<span>套餐订购</span>
							</a>
						</div>
						<div>
							<a href="javascript: void(0);" @click="toRecharge1()">
								<img src="@/assets/home/icon06.png" alt="" />
								<div class="shadow"></div>
								<span>智能复机</span>
							</a>
						</div>
						<div>
							<a href="javascript: void(0);" @click="pkgListVisible = true">
								<img src="@/assets/home/icon08.png" alt="" />
								<div class="shadow"></div>
								<span>可用套餐</span>
							</a>
						</div>
						<div>
							<a href="javascript: void(0);" @click="pkgListVisible1 = true">
								<img src="@/assets/home/icon09.png" alt="" />
								<div class="shadow"></div>
								<span>次月套餐</span>
							</a>
						</div>
						<div v-if="cuccAuthShow">
							<a href="javascript:void(0)" @click="cuccAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="cmccXxtx">
							<a href="javascript:void(0)" @click="cmccXxtxmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="ctccAuthShow">
							<a href="javascript:void(0)" @click="ctccAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="cmccAuthShow">
							<a href="javascript:void(0)" @click="cmccAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="leyuAuthShow">
							<a href="javascript:void(0)" @click="leyuAuthShowmethod()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else-if="otherAuth">
							<a href="javascript:void(0)" @click="otherAuthM()">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>
						<div v-else>
							<a
								:href="`#/user/verified?state=${state}&supplierTypeCode=${simInfo.supplierTypeCode}&realNameCard=${simInfo.realNameCard}`">
								<img src="@/assets/home/icon14.png" alt="" />
								<div class="shadow"></div>
								<span>实名登记</span>
							</a>
						</div>

						<div>
							<a href="javascript:void(0)" @click="buyCard()">
								<img src="@/assets/home/icon07.png" alt="" />
								<div class="shadow"></div>
								<span>在线购买</span>
							</a>
						</div>

						<div>
							<a href="javascript: void(0);" @click="analysisHandler()">
								<img src="@/assets/home/icon10.png" alt="" />
								<div class="shadow"></div>
								<span>刷新复机</span>
							</a>
						</div>
						<div>
							<a href="javascript:void(0)" @click="toChgCardQuery()">
								<img src="@/assets/home/15.png" alt="" />
								<div class="shadow"></div>
								<span>换卡申请</span>
							</a>
						</div>

						<div>
							<a href="#/user/balanceRechargeRecord">
								<img src="@/assets/home/icon11.png" alt="" />
								<div class="shadow"></div>
								<span>充值记录</span>
							</a>
						</div>

						<div>
							<a href="javascript:void(0)" @click="logoutHandler()">
								<img src="@/assets/home/icon13.png" alt="" />
								<div class="shadow"></div>
								<span>卡板退出</span>
							</a>
						</div>
					</div>
					<!--  代理商端 end -->
				</div>
				<!--  main-bottom” class   end  -->
			</div>
			<!--  “content-bottom” class   end  -->
		</div>
		<!--  “main” class   end  -->

		<p class="tip" v-if="showSupplierTip">
			部分用户如果充值后上不了网，请设置<br />APN：iotdunj.grevpdn.sd，重启便可
		</p>
		<!-- 修改密码框   -->
		<div class="van-overlay" style="z-index: 1999" v-show="showPasswordPanel"></div>
		<div class="van-popup van-popup--round van-popup--center changePasswordPanel"
			style="z-index: 2000; min-height: 55%; min-width: 80%" v-show="showPasswordPanel"
			:style="{ top: passwordPanelTop + '%' }">
			<van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />

			<!-- 原密码输入框 -->
			<p>原密码：</p>
			<van-password-input :value="oldPassword" :focused="oldPasswordKeyboard" @focus="oldPasswordOnfocus()" />
			<!-- 新密码输入框 -->
			<p>新密码：</p>
			<van-password-input :value="newPassword" :focused="newPasswordKeyboard" @focus="newPasswordOnfocus()" />
			<!-- 原密码输入框 -->
			<p>再次确认：</p>
			<van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard"
				@focus="confirmPasswordOnfocus()" />
			<div class="confirmChangePassword">
				<van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToChangePassword()">确
					定</van-button>
			</div>
		</div>

		<!-- 数字键盘 -->
		<van-number-keyboard :z-index="2015" :show="oldPasswordKeyboard" @input="oldPasswordOnInput"
			@delete="oldPasswordOnDelete" @blur="oldPasswordKeyboard = false" />

		<van-number-keyboard :z-index="2015" :show="newPasswordKeyboard" @input="newPasswordOnInput"
			@delete="newPasswordOnDelete" @blur="newPasswordKeyboard = false" />

		<van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
			@delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />
		<!-- 数字键盘 end -->
		<!-- 修改密码框 end  -->

		<!--  更多套餐信息  -->
		<van-popup v-model="pkgListVisible" closeable position="bottom" style="min-height: 35%; max-height: 75%">
			<div class="pkgList">
				<h3 v-show="simInfo.simPackageList[0]">当前套餐:</h3>
				<h3 v-show="!simInfo.simPackageList[0]" style="color: red">
					未订购可用套餐
				</h3>
				<ul>
					<li v-for="item in simInfo.simPackageList" :key="item.id">
						<p>{{ item.packageName }}</p>
						<p v-if="item.stateName == '已充值'" style="color: #32c5e9">
							已充值
						</p>
						<p v-else style="color: red">充值中</p>
						<div>
							<p>生效时间： {{ item.startTime }}</p>
							<p v-if="new Date(
								getDateByTimeStr(item.endTime)[0],
								getDateByTimeStr(item.endTime)[1],
								getDateByTimeStr(item.endTime)[2],
								getDateByTimeStr(item.endTime)[3],
								getDateByTimeStr(item.endTime)[4],
								getDateByTimeStr(item.endTime)[5]
							) < new Date()
								" style="color: red">
								过期时间： {{ item.endTime }}
							</p>
							<p v-else>过期时间： {{ item.endTime }}</p>
						</div>
					</li>
				</ul>
			</div>
		</van-popup>
		<van-popup v-model="pkgListVisible1" closeable position="bottom" style="min-height: 35%; max-height: 75%">
			<div class="pkgList">
				<h3 v-show="simInfo.simNextPackageList[0]">次月套餐:</h3>
				<h3 v-show="!simInfo.simNextPackageList[0]" style="color: red">
					未订购次月套餐
				</h3>
				<ul>
					<li v-for="item in simInfo.simNextPackageList" :key="item.id">
						<p>{{ item.packageName }}</p>
						<p v-if="item.stateName == '已充值'" style="color: #32c5e9">
							已充值
						</p>
						<p v-else style="color: red">充值中</p>
						<div>
							<p>生效时间： {{ item.startTime }}</p>
							<p v-if="new Date(
								getDateByTimeStr(item.endTime)[0],
								getDateByTimeStr(item.endTime)[1],
								getDateByTimeStr(item.endTime)[2],
								getDateByTimeStr(item.endTime)[3],
								getDateByTimeStr(item.endTime)[4],
								getDateByTimeStr(item.endTime)[5]
							) < new Date()
								" style="color: red">
								过期时间： {{ item.endTime }}
							</p>
							<p v-else>过期时间： {{ item.endTime }}</p>
						</div>
					</li>
				</ul>
			</div>
		</van-popup>
		<!--  更多套餐信息  end -->
		<!--  智能诊断提醒  -->
		<van-dialog v-model="analysisHandlerData.analysisHandlerDialog" class="analysisHandlerDialog" title="诊断完成">
			<p><span>卡号：</span>{{ this.$store.state.recordLoginText }}</p>
			<p>
				<span>当前套餐：</span>
				{{ analysisHandlerData.packageName }}
				<a href="javascript: void(0);" style="color: #1989fa; float: right" @click="showMoreAfterAnalysis()">更 多</a>
			</p>
			<p>
				<span>剩余流量：</span>{{
					fluxMtoG(
						analysisHandlerData.flowRate - analysisHandlerData.usedFlowRate
					)
				}}
				G
			</p>
			<p><span>有效期：</span>{{ analysisHandlerData.endTime }}</p>
			<p><span>状态：</span>{{ analysisHandlerData.simState }}</p>
			<p>
				公众号点击智能诊断，点击更新均可加速复机过程。如果刚充值不满30分钟，请耐心等待即可。
			</p>
		</van-dialog>

		<!-- 图片实名认证 -->
		<van-dialog v-model="showimg" title="请扫描下方二维码" show-cancel-button>
			<p>复制此处iccid，然后扫码实名：</p>
			<p>{{ iccid }}</p>
			<img style="width: 100%" src="@/assets/suolangunicom.jpg" />
		</van-dialog>
		<!-- APP 下载 -->
		<van-dialog v-model="appshowimg" title="微信识别下方二维码 进行下载" show-cancel-button>
			<img style="width: 100%" src="@/assets/app.png" />
		</van-dialog>
		<div class="signOut">
			<a style="color: #333" @click="logoutHandler()">退 出</a>
		</div>



		<van-dialog v-model="isTitle" title="温馨提示" confirmButtonColor="#86de6b" confirmButtonText="知道了">
			<img style="width: 100%" :src="titleImg" @click="sureToUrl()">
			<div style="font-size: 14px;color:#999;padding-top:6px;text-align: center;">更多详情，请联系专属客服咨询</div>
		</van-dialog>


	</div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SuspendButton from "@/components/SuspendButton";
import Clipboard from "clipboard";
export default {
	components: {
		SuspendButton,
	},
	name: "home",
	data() {
		return {
			guangdianAuth: false,
			jiaAuth: false,
			isMyLogin: localStorage.getItem("isMyLogin") == 0 ? true : false,
			isAgentLogin: localStorage.getItem("isAgentLogin"),
			yucun: localStorage.getItem("yucun"),
			isSale: localStorage.getItem("isSale"),
			shebeiLogin: localStorage.getItem("shebeiLogin"),
			ishavePkg: localStorage.getItem("ishavePkg"),
			ishavePrice: localStorage.getItem("ishavePrice"),
			kefuUrl: localStorage.getItem("kefuUrl"),
			otherUrl: "",
			otherAuth: false,
			appshowimg: false,
			btnIndex: "1",
			isSHowShop: localStorage.getItem("agentId"),
			leshuaPay: localStorage.getItem("leshuaPay"),
			flowRatePool: localStorage.getItem("flowRatePool"),
			iccid: localStorage.getItem("iccid"),
			iccidCopy: "",
			state: "",
			stateName: "",
			wxHeadImg: localStorage.getItem("wxHeadImg"),
			showPhone: localStorage.getItem("showPhone"),
			userPhone: localStorage.getItem("userPhone"),
			wxNickName: localStorage.getItem("wxNickName"),
			showSupplierTip: false, //
			wxCircle: 0,
			simInfo: {
				simId: "",
				simPackageList: [],
				simNextPackageList: [],
				supplierTypeCode: "",
				packageName: null,
				endTime: null,
			},
			cmccXxtx: false,
			isAuthName: "未实名/未知",

			userAccount: {
				amount: 0,
			},
			notifyContent: "APP已上架！更多优惠活动请下载查询",
			alreadyHasAccount: false,
			canChangeCard: false, //是否可申请换卡

			userInfo: {
				oldIccid: "",
				takeNickname: "",
				takePhone: "",
				takeAddress: "",
				disposeState: "",
				disposeRemark: "",
				changeCmccSim: 6,
				changeCmccSimName: "",
				pcaAddress: "",
			},

			//修改密码
			showPasswordPanel: false,

			oldPasswordKeyboard: false,
			newPasswordKeyboard: false,
			confirmPasswordKeyboard: false,

			oldPassword: "",
			newPassword: "",
			confirmPassword: "",
			passwordPanelTop: 50,
			//修改密码 end

			pkgListVisible: false,
			pkgListVisible1: false,

			//卡片管理弹出层列表
			showIccidList: false,
			iccidList: [],
			refreshIccidList: true,
			defaultIccid: localStorage.getItem("iccid"),

			//智能诊断提醒
			analysisHandlerData: {
				analysisHandlerDialog: false,
				iccid: null,
				packageName: null,
				flowRate: null,
				usedFlowRate: null,
				endTime: null,
				simState: null,
			},
			realNameCard: -1,
			realNameList: [
				"1275376999107391488",
				"1275377681088638976",
				"1275377775070408704",
				"1339095354397683712",
			],
			suolangList: ["1377889272299778048"],
			showimg: false,
			cuccAuthShow: false,
			ctccAuthShow: false,
			cmccAuthShow: false,
			qianhaiList: ["1334017617676988416"],
			qianhaiSHow: false,
			leyuAuthShow: false,
			qianhaiUrls:
				"http://wechat.liuliangka.co/#/user/verifiedOtherQh?iccid=" +
				localStorage.getItem("iccid"),



			isTitle: false,
			titleImg: "http://vx.iot688.cn:8888/" + localStorage.getItem("titleImg"),
			titleUrl: localStorage.getItem("titleUrl"),
			ctccOldAuth: false,
		};
	},

	computed: {},
	methods: {
		sureToUrl() {
			localStorage.setItem("isTitle", 0);
			if (this.titleUrl && this.titleUrl == '套餐') {
				this.$router.push('/user/recharge');
			} else if (this.titleUrl && this.titleUrl == '余额') {
				this.$router.push('/user/balanceRecharge');
			} else if (this.titleUrl) {
				window.location.href = this.titleUrl;
			}
		},


		toGaungdianAuth() {
			wxRequest("wxAuth/ctcc/auth", {
				iccid: localStorage.getItem('iccid'),
				intoNo: this.simInfo.intoNo
			}, 'post').then(res => {
				if (res.data.code == 200) {
					Dialog.alert({
						message: '已实名'
					})
				} else if (res.data.code == 302) {
					Dialog.confirm({
						message: '尊敬的用户你好，请先购买套餐后 再进行实名操作',
						confirmButtonText: '去购买',
						cancelButtonText: '取消'
					}).then(() => {
						this.$router.push('/user/recharge');
					}).catch(() => {
					});
				} else {
					this.$router.push('/user/ctccGdAuth');
				}
			})
		},
		toCtccoldAth() {
			this.$router.push('/user/ctccAuth');
		},
		toJiaAuth() {
			wxRequest("wxAuth/ctcc/auth", {
				iccid: localStorage.getItem('iccid'),
				intoNo: this.simInfo.intoNo
			}, 'post').then(res => {
				if (res.data.code == 200) {
					Dialog.alert({
						message: '已实名'
					})
				} else if (res.data.code == 302) {
					Dialog.confirm({
						message: '尊敬的用户你好，请先购买套餐后 再进行实名操作',
						confirmButtonText: '去购买',
						cancelButtonText: '取消'
					}).then(() => {
						this.$router.push('/user/recharge');
					}).catch(() => {
					});
				} else {
					this.$router.push('/user/bindPhoneAuth');
				}
			})
		},




		submitFeedback() {
			this.$router.push({
				path: "/user/entrance",
				query: {
					iccid: this.$store.state.iccid,
				},
			});
		},
		toBalanceRecharge1() {
			let fd = new FormData();
			fd.append("supplierId", sessionStorage.getItem("supplierCode"));
			wxRequest("sim/invent/state", fd, "post").then((res) => {
				if (res.data.code == 200) {
					this.$router.push({
						path: "/user/huodong",
						query: {
							iccid: this.$store.state.iccid,
						},
					});
				} else {
					Dialog.alert({ title: "提示", message: res.data.message });
				}
			});
		},
		bindList() {
			this.$router.replace("/user/bindPhoneList");
		},
		toKefu() {
			if (this.kefuUrl) {
				window.location.href = this.kefuUrl;
			} else {
				Dialog.alert({ title: "提示", message: "功能即将上线！" });
			}
		},
		toApplyShops() {
			this.$router.push({
				name: "applySalePkg",
				query: { iccid: this.simInfo.iccid },
			});
		},
		// 切换
		btnChange(i) {
			this.btnIndex = i;
		},
		toRecharge12() {
			this.$router.push({ path: '/user/renew', query: { iccid: this.$store.state.iccid } })
		},
		buyCardapp() {
			this.appshowimg = true;
		},
		cmccXxtxmethod() {
			wxRequest(
				"wxAuth/cmcc/auth",
				{ iccid: this.$store.state.iccid },
				"post"
			).then((res) => {
				if (res.data.code == "200") {
					window.location.href = res.data.data;
				} else {
					Dialog.alert({
						title: "提示",
						message: res.data.message,
					});
				}
			});
		},
		buyCardapp1() {
			this.$router.push({
				path: "/user/AppLoadp",
				query: {
					realNameCard: 1,
				},
			});
		},
		copy() {
			var clipboard = new Clipboard(".tag-read");
			clipboard.on("success", (e) => {
				console.log("复制成功");
				alert("复制成功");
				clipboard.destroy(); // 释放内存
			});
			clipboard.on("error", (e) => {
				console.log("不支持复制,该浏览器不支持自动复制");
				alert("复制失败");
				clipboard.destroy(); // 释放内存
			});
		},
		otherAuthM() {
			if (this.isAuthName == "请先购买套餐") {
				Dialog.confirm({
					message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
					confirmButtonText: "去购买",
					cancelButtonText: "取消",
				})
					.then(() => {
						this.$router.push("/user/recharge");
					})
					.catch(() => { });
				return;
			}
			window.location.href = this.otherUrl;
		},
		getUserSimInfo() {
			wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then((res) => {
				if (res.data.code == 200) {
					let result = res.data.data;
					if (result.flowRatePool == "5G电信") {
						this.ctccAuthShow = true;
					} else if (result.flowRatePool == "联通") {
						this.cuccAuthShow = true;
					} else if (result.flowRatePool == "前海") {
						this.qianhaiSHow = true;
					} else if (result.flowRatePool == "移动") {
						this.cmccAuthShow = true;
					} else if (result.flowRatePool == "乐语") {
						this.leyuAuthShow = true;
					} else if (result.flowRatePool == "移动接口") {
						this.cmccXxtx = true;
					} else if (result.flowRatePool == '广电') {
						this.guangdianAuth = true;
					} else if (result.flowRatePool == '假实名') {
						this.jiaAuth = true;
					} else if (result.flowRatePool == '电信') {
						this.ctccOldAuth = true;
					} else {
						if (result.flowRatePool.indexOf('?') > 0) {
							this.otherUrl = result.flowRatePool + '&cn=' + localStorage.getItem('recordLoginText');
						} else {
							this.otherUrl = result.flowRatePool + "?cn=" + localStorage.getItem('recordLoginText');
						}
						this.otherAuth = true;
					}
					wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem("iccid"), intoNo: result.intoNo, }, "post").then((res) => {
						if (res.data.code == 200) {
							this.isAuthName = "已实名";
						} else if (res.data.code == 302) {
							this.isAuthName = "请先购买套餐";
						}
						sessionStorage.setItem("alreadyCertification", "true");
					});
					sessionStorage.setItem("supplierCode", result.supplierCode);

					this.simInfo = result;

					if (result.simPackageList.length > 1) {
						for (let i = 0; i < result.simPackageList.length; i++) {
							if (
								result.simPackageList[i].flowRatePercent &&
								(result.simPackageList[i].flowRatePercent / 100) *
								result.simPackageList[i].flowRate >
								result.simPackageList[i].usedFlowRate
							) {
								this.simInfo.packageName =
									result.simPackageList[i].packageName;
								this.simInfo.endTime = result.simPackageList[i].endTime;
								break;
							}
						}
					} else if (result.simPackageList.length == 1) {
						this.simInfo.packageName = result.simPackageList[0].packageName;
						this.simInfo.endTime = result.simPackageList[0].endTime;
					}
					this.simInfo.simId = this.simInfo.simPackageList[0] ? this.simInfo.simPackageList[0].simId : "";

					//画流量仪表盘
					let progressRate = this.simInfo.usedFlowRate ? Math.floor((this.simInfo.usedFlowRate / this.simInfo.flowRate) * 100) : 0;
					let fz = 40;
					if (progressRate == 100) {
						fz = 30;
					}
					this.wxCircle = progressRate;
					// this.drawProgressBar("home_progressBar", 2222, 3.14, '#008fd0', '#0765c3', 85, fz, "inner");
				}
			}
			);
		},
		cuccAuthShowmethod() {
			wxRequest(
				"wxAuth/ctcc/auth",
				{
					iccid: localStorage.getItem("iccid"),
					intoNo: this.simInfo.intoNo,
				},
				"post"
			).then((res) => {
				if (res.data.code == 200) {
					Dialog.alert({
						message: "已实名",
					});
				} else if (res.data.code == 302) {
					Dialog.confirm({
						message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
						confirmButtonText: "去购买",
						cancelButtonText: "取消",
					})
						.then(() => {
							this.$router.push("/user/recharge");
						})
						.catch(() => { });
				} else {
					window.location.href = 'http://vx.iot688.cn/#/user/cuccAuth';
				}
			});
		},
		toRecharge1() {
			wxRequest(
				"sim/to/active",
				{ iccid: localStorage.getItem("iccid") },
				"get"
			).then((res) => {
				Dialog.alert({ message: res.data.message });
			});
		},
		ctccAuthShowmethod() {
			if (this.isAuthName == "请先购买套餐") {
				Dialog.confirm({
					message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
					confirmButtonText: "去购买",
					cancelButtonText: "取消",
				})
					.then(() => {
						this.$router.push("/user/recharge");
					})
					.catch(() => { });
			} else if (this.isAuthName != "已实名") {
				wxRequest(
					"wxAuth/ctcc/to/5G/auth",
					{ iccid: this.simInfo.iccid },
					"post"
				).then((res) => {
					if (res.data.code == "200") {
						window.location.href = res.data.data;
					} else {
						Dialog.alert({
							title: "提示",
							message: res.data.message,
						});
					}
				});
			} else {
				Dialog.alert({ title: "提示", message: "已实名" });
			}
		},
		cmccAuthShowmethod() {
			if (this.isAuthName == "请先购买套餐") {
				Dialog.confirm({
					message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
					confirmButtonText: "去购买",
					cancelButtonText: "取消",
				})
					.then(() => {
						this.$router.push("/user/recharge");
					})
					.catch(() => { });
			} else if (this.isAuthName != "已实名") {
				this.$router.push({
					path: "/user/cmccAuth",
					query: {
						realNameCard: 1,
					},
				});
			} else {
				Dialog.alert({
					title: "提示",
					message: "已实名",
				});
			}
		},
		leyuAuthShowmethod() {
			if (this.isAuthName == "请先购买套餐") {
				Dialog.confirm({
					message: "尊敬的用户你好，请先购买套餐后 再进行实名操作",
					confirmButtonText: "去购买",
					cancelButtonText: "取消",
				})
					.then(() => {
						this.$router.push("/user/recharge");
					})
					.catch(() => { });
			} else if (this.isAuthName != "已实名") {
				this.$router.push({
					path: "/user/leyuAuth",
					query: {
						realNameCard: 1,
					},
				});
			} else {
				Dialog.alert({
					title: "提示",
					message: "已实名",
				});
			}
		},

		logoutHandler() {
			localStorage.removeItem("iccid");
			//若为总部微信公众号
			if (this.$store.state.isHeadquarterAppid == "true") {
				window.location.href = "http://vx.iot688.cn/#/user/";
			}
			//若为代理商微信公众号
			else {
				window.location.href =
					window.location.origin + "/?source=" + localStorage.getItem("appid");
			}
		},

		toChgCardQuery() {
			/**   换卡判断       **/
			let fd = new FormData();
			let oldIccid = localStorage.getItem("iccid");
			fd.append("iccid", oldIccid);
			wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
				if (res.data.code == "200") {
					let cardType = 0;
					if (res.data.data) {
						cardType = res.data.data.cardType;
					}

					this.$router.push({
						name: "userChgCard",
						query: {
							oldIccid: oldIccid,
							changeCmccSim: 2,
						},
					});
				} else {
					Dialog.alert({
						title: "提示",
						message: res.data.message,
					});
				}
			});

			/**     换卡判断   end    **/
		},

		toRecharge() {
			//若为总部微信公众号
			if (this.$store.state.isHeadquarterAppid == "true") {
				let fd = new FormData();
				fd.append("supplierId", sessionStorage.getItem("supplierCode"));
				wxRequest("sim/invent/state", fd, "post").then((res) => {
					if (res.data.code == 200) {
						if (this.userAccount.amount < 0) {
							Dialog.confirm({
								title: "提示",
								message: "您的账户余额已透支，请先充值账户余额！",
							})
								.then(() => {
									// on confirm
									this.$router.push({
										path: "/user/balanceRecharge",
										query: {
											iccid: this.$store.state.iccid,
										},
									});
								})
								.catch(() => { });
						} else {
							this.$router.push({
								path: "/user/recharge",
								query: {
									iccid: this.$store.state.iccid,
								},
							});
							console.log(this.$router)
						}
					} else {
						Dialog.alert({
							title: "提示",
							message: res.data.message,
						});
					}
				});
			}

			//若为代理商微信公众号
			else {
				this.$router.push({
					path: "/user/recharge",
					query: {
						iccid: this.$store.state.iccid,
					},
				});
			}
		},

		toBalanceRecharge() {
			let fd = new FormData();
			fd.append("supplierId", sessionStorage.getItem("supplierCode"));
			wxRequest("sim/invent/state", fd, "post").then((res) => {
				if (res.data.code == 200) {
					this.$router.push({
						path: "/user/balanceRecharge",
						query: {
							iccid: this.$store.state.iccid,
						},
					});
				} else {
					Dialog.alert({
						title: "提示",
						message: res.data.message,
					});
				}
			});
		},

		getAccount() {
			let param = {
				iccid: this.$store.state.iccid,
				mobile: localStorage.getItem("mobile"),
			};
			//若为总部微信公众号
			if (this.$store.state.isHeadquarterAppid == "true") {
				wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
					(res) => {
						if (res.data.code == 200) {
							this.userAccount = res.data.data;
							this.alreadyHasAccount = true;
						} else if (res.data.code == 400) {
							let self = this;

							if (self.$store.state.supplierCode == "1197749413972275200") {
								Dialog.confirm({
									title: "提示",
									message: "首次使用需进行充值，请点击【确认】前往充值",
								})
									.then(() => {
										// on confirm
										self.$router.push({
											path: "/user/cardSetUp",
											query: {
												iccid: self.$store.state.iccid,
											},
										});
									})
									.catch(() => { });
							}
						}
					}
				);
			}

			//若为代理商公众号
			else {
				wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
					(res) => {
						if (res.data.code == 200) {
							this.userAccount = res.data.data;
							this.alreadyHasAccount = true;
						}
					}
				);
			}
		},

		//跳往更多公告页面
		toMoreNotify() {
			this.$router.push({
				path: "/user/notify",
			});
		},

		//一键智能诊断
		analysisHandler() {
			let _this = this;
			let data = new FormData();
			data.append("iccid", this.$store.state.iccid);

			//应后端要求  两次请求
			wxRequest("sim/update/stateRateFlow", data, "post").then((res) => {
				wxRequest("sim/select/stateRateFlow/info", data, "post").then(
					(newRes) => {
						if (newRes.data.code == 200) {
							let resultList = newRes.data.data.simPkg;
							if (resultList.length > 1) {
								for (let i = 0; i < resultList.length; i++) {
									if (
										resultList[i].flowRatePercent &&
										(resultList[i].flowRatePercent / 100) *
										resultList[i].flowRate >
										resultList[i].usedFlowRate
									) {
										for (let key in this.analysisHandlerData) {
											this.analysisHandlerData[key] = resultList[i][key];
										}
										break;
									}
								}
							} else if (resultList.length == 1) {
								for (let key in this.analysisHandlerData) {
									this.analysisHandlerData[key] = resultList[0][key];
								}
							}
							this.analysisHandlerData.simState = newRes.data.data.simState;
							this.analysisHandlerData.analysisHandlerDialog = true;
							this.getUserSimInfo();
						} else {
							Dialog.alert({
								title: "提示",
								message: newRes.data.message,
							});
						}
					}
				);
			});
		},

		showMoreAfterAnalysis() {
			this.analysisHandlerData.analysisHandlerDialog = false;
			this.pkgListVisible = true;
		},

		// 更新状态、流量比
		updateStateRateFlow(isSingleTouch) {
			if (isSingleTouch) {
				let fd = new FormData();
				fd.append("iccid", this.$store.state.iccid);
				wxRequest("sim/select/stateRateFlow", fd, "post").then((res) => {
					this.getUserSimInfo();
				});
			}
		},

		//机卡重绑
		reBind() {
			let param = {
				intoNo: this.simInfo.intoNo,
				supplierCode: this.simInfo.supplierCode,
			};
			wxRequest("sim/unbind", param, "post").then((res) => {
				if (res.data.message) {
					Dialog.alert({
						title: "提示",
						message: res.data.message,
					});
				}
			});
		},

		//获取绑定的卡片列表
		getBindIccidListHandler() {
			// var data = {
			// 	userPhone: localStorage.getItem('mobile')
			// }
			// wxRequest("bindPhone/list", data, "post").then(res => {
			// 	if (res.data.code == 200) {
			// 		this.refreshIccidList = false;
			// 		this.$nextTick(() => {
			// 			this.refreshIccidList = true;
			// 			this.iccidList = res.data.data;
			// 		})
			// 	} else {
			// 		// Dialog.alert({title:'提示', message: res.data.message})
			// 	}
			// })
		},

		//卡片管理
		deleteBindIccidHandler(iccid) {
			Dialog.confirm({
				message: "您确定删除吗？",
			})
				.then((action) => {
					var data = {
						iccid,
						userPhone: localStorage.getItem("mobile"),
					};
					wxRequest("bindPhone/delete", data, "post").then((res) => {
						if (res.data.code == 200) {
							Toast.success("删除成功");
							if (res.data.data == null || res.data.data.length == 0) {
								window.location.href = window.location.origin + "#/user";
							} else {
								this.getBindIccidListHandler();
								this.showIccidList = false;
							}
						} else {
							Dialog.alert({
								title: "提示",
								message: res.data.message,
							});
						}
					});
				})
				.catch(() => { });
		},
		updateDefaultBindIccidHandler(iccid) {
			var data = {
				iccid: this.defaultIccid,
				defaultIccid: iccid,
			};
			wxRequest("bindPhone/update/default", data, "post").then((res) => {
				if (res.data.code == 200) {
					Dialog.alert({
						title: "提示",
						message: "设置成功，将会退出重新登录",
					}).then(() => {
						localStorage.setItem("iccid", iccid);
						window.location.href = window.location.origin + "/";
					});
				} else {
					Dialog.alert({
						title: "提示",
						message: res.data.message,
					});
				}
			});
		},

		/***   修改密码     ***/
		oldPasswordOnfocus() {
			this.oldPasswordKeyboard = true;
			this.newPasswordKeyboard = false;
			this.confirmPasswordKeyboard = false;
			this.passwordPanelTop = 30;
		},
		oldPasswordOnDelete() {
			this.oldPassword = this.oldPassword.slice(0, this.oldPassword.length - 1);
		},

		oldPasswordOnInput(key) {
			this.oldPassword = (this.oldPassword + key).slice(0, 6);
		},

		newPasswordOnfocus() {
			this.oldPasswordKeyboard = false;
			this.newPasswordKeyboard = true;
			this.confirmPasswordKeyboard = false;
			this.passwordPanelTop = 30;
		},
		newPasswordOnDelete() {
			this.newPassword = this.newPassword.slice(0, this.newPassword.length - 1);
		},

		newPasswordOnInput(key) {
			this.newPassword = (this.newPassword + key).slice(0, 6);
		},

		confirmPasswordOnfocus() {
			this.oldPasswordKeyboard = false;
			this.newPasswordKeyboard = false;
			this.confirmPasswordKeyboard = true;
			this.passwordPanelTop = 30;
		},
		confirmPasswordOnDelete() {
			this.confirmPassword = this.confirmPassword.slice(
				0,
				this.confirmPassword.length - 1
			);
		},

		confirmPasswordOnInput(key) {
			this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
		},

		cancelChangePassword() {
			this.oldPassword = "";
			this.newPassword = "";
			this.confirmPassword = "";
			this.passwordPanelTop = 50;
			this.showPasswordPanel = false;
		},

		sureToChangePassword() {
			if (
				this.oldPassword.length < 6 ||
				this.newPassword.length < 6 ||
				this.confirmPassword.length < 6
			) {
				Dialog.alert({
					message: "请输入六位密码",
				});
				return;
			}

			if (this.newPassword != this.confirmPassword) {
				Dialog.alert({
					message: "两次输入的新密码不一致",
				});
				return;
			}

			let data = {
				iccid: this.$store.state.iccid,
				paypassOld: this.oldPassword,
				paypass: this.confirmPassword,
			};
			wxRequest("sysUser/account/user/resetPaypass", data, "post").then(
				(res) => {
					if (res.data.code == 200) {
						Toast.success(res.data.message);
						this.cancelChangePassword();
					} else {
						Dialog.alert({
							message: res.data.message,
						});
					}
				}
			);
		},
		/***   修改密码  end   ***/

		getDateByTimeStr(timeStr) {
			if (timeStr && typeof timeStr === "string") {
				let dayStr = timeStr.split(" ")[0].split("-");
				let hourStr = timeStr.split(" ")[1].split(":");
				return dayStr.concat(hourStr);
			}
			return timeStr;
		},

		//电信实名查询
		realNameSearch() {
			wxRequest(
				"wxAuth/ctcc/auth",
				{
					iccid: localStorage.getItem("iccid"),
					intoNo: this.simInfo.intoNo,
				},
				"post"
			).then((res) => {
				if (res.data.code == 200) {
					Dialog.alert({
						message: res.data.data.msg,
					});
				} else {
					Dialog.alert({
						message: res.data.message,
					});
				}
			});
		},

		//买卡
		buyCard() {
			wxRequest(
				"applyChangeSim/select/agent/buy/power",
				{
					oldIccid: localStorage.getItem("iccid"),
				},
				"post"
			).then((res) => {
				if (res.data.code == 200) {
					this.$router.push("/user/liuliangka?agentId=" + this.simInfo.agentId);
				} else {
					Dialog.alert({
						message: res.data.message,
					});
				}
			});
		},
		//买卡
		buyCard1() {
			window.location.href =
				"https://shop42633196.m.youzan.com/v2/home/yaNx0wAQRn?kdt_id=42441028&dc_ps=2620847902846765057.300001&scan=3&from=kdt";
		},
	},
	created() {
		let fd = new FormData();
		fd.append("iccid", localStorage.getItem("iccid"));

		this.$store.state.recordLoginText = localStorage.getItem("recordLoginText");
		var data = {
			iccid: this.$store.state.iccid,
		};
		this.iccidCopy = this.$store.state.iccid;
		// wxRequest("wxAuth/state", data, "post").then(res => {
		// 	if (res.data.code == 200) {
		// 		if (res.data.data.supplierCode == 'B1E112B9F1D8420E9072D9F47D6A135E') {
		// 			this.showSupplierTip = true;
		// 		} else {
		// 			this.showSupplierTip = false;
		// 		}
		// 		var result = res.data.data;
		// 		this.state = result.authState;
		// 		this.stateName = result.authStateNick;
		// 	}
		// });

		//获取绑定的卡片列表
		this.getBindIccidListHandler();

		//获取首条公告
		wxRequest("sim/notice/top", fd, "post").then((res) => {
			if (res.data.code == "200") {
				this.notifyContent = res.data.data.content;
			}
		});
	},

	mounted() {
		/**   换卡判断       **/
		let fd = new FormData();
		fd.append("iccid", localStorage.getItem("iccid"));
		// if(this.$store.state.isHeadquarterAppid=='true'){
		wxRequest("applyChangeSim/isChange", fd, "post").then((res) => {
			if (res.data.code == "200") {
				this.canChangeCard = true;
				let cardType = 0;
				let cardTypeStr = "电信";
				if (res.data.data) {
					cardType = res.data.data.cardType;
					cardTypeStr =
						res.data.data.cardType == 0
							? "移动"
							: res.data.data.cardType == 1
								? "电信"
								: "联通";
				}

				//公司本部公众号
				if (localStorage.getItem("isHeadquarterAppid") == "true") {
					Dialog.alert({
						title: "提示",
						messageAlign: "left",
						message:
							"尊敬的用户:由于运营商政策影响，造成184号段电信卡无法使用了，现做出以下处理：给您换卡使用，新卡不会出现这种情况，新卡为广电Pro，套餐给您转移，24小时内发货，京东快递1-3天到货",
					}).then((action) => {
						this.$router.push({
							name: "userChgCard",
							query: {
								oldIccid: localStorage.getItem("iccid"),
								changeCmccSim: cardType,
							},
						});
					});

				} else {
					Dialog.alert({
						title: "提示",
						messageAlign: "left",
						message:
							"尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，请联系您的经销商，谢谢！",
					});
				}
			} else if (this.isSale > 0 && this.ishavePkg == 0 && this.ishavePrice == 1) {
				Dialog.confirm({ title: '活动提醒', message: '您已成功参与购买优惠券活动。每月购买套餐可使用优惠券抵消套餐金额，请购买套餐正常使用。' }).then(action => {
					if (action == 'confirm') {
						this.$router.replace("/user/balanceRecharge");
					}
				})
			} else if (this.showPhone != 1 && this.userPhone.length > 5) {
				this.showPhone = 1;
				localStorage.setItem('showPhone', 1);
				Dialog.confirm({ title: '温馨提示', message: '您当前绑定的手机号为' + this.userPhone + '。如有误 请点击 确定 前往更改.' }).then(action => {
					if (action == 'confirm') {
						this.$router.replace("/user/bindPhoneList");
					}
				})
			} else if (this.yucun == 1) {
				Dialog.confirm({
					message: "你有一个首月免费卷待领取,点击领取！",
					confirmButtonText: "立即领取",
					cancelButtonText: "暂不需要",
				})
					.then(() => {
						this.$router.push("/user/huodong");
					})
					.catch(() => { });
			} else if (this.yucun == 3) {
				Dialog.confirm({
					message: "你有一个叠加卷待领取,点击领取！",
					confirmButtonText: "立即领取",
					cancelButtonText: "暂不需要",
				})
					.then(() => {
						this.$router.push("/user/huodong2");
					})
					.catch(() => { });
			} else if (localStorage.getItem("isTitle") == 1) {
				this.isTitle = true;
			}
		});
		// }

		/**     换卡判断   end    **/

		this.getUserSimInfo();
		this.getAccount();
	},

	beforeRouteLeave(to, from, next) {
		if (to.path == "/user") {
			window.location.href = window.location.origin + "#/user";
		}
		next();
	},
};
</script>



<style lang="less">
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

#home_progressBar {
	position: absolute;
	width: 14.5rem;
	height: 14.5rem;
	top: -25px;
	left: calc(50% - 7.25rem);
}

#home {
	height: auto;
	background: #fff;

	a {
		color: #2c3e50;
	}

	.home-top {
		color: #fff;
		height: 185px;
		// background-image: linear-gradient(#2452c8, #fff);
		background-image: linear-gradient(#F23E3D, #fff);
		position: relative;

		.el-vant-status {
			position: absolute;
			width: 94%;
			top: 49%;
			bottom: 0;
			left: 0;
			right: 0;
			margin: 0 auto;
			height: 286px;
			background: #fff;
			border-radius: 16px;
			padding-top: 0;
			box-shadow: 0px 3px 11px 0px rgba(193, 193, 193, 0.51);

			.status-info {
				display: flex;
				height: 20px;
				margin-bottom: 0.6875rem;

				.status-info-left {
					color: #333333;
					font-weight: 500;
					font-family: PingFangSC-Medium, PingFang SC;
					width: 40%;
				}

				.status-info-right {
					color: #a2a2a2;
					font-size: 0.75rem;
					line-height: 0.875rem;
					width: 60%;
					text-align: right;
				}
			}

			.el-col-row {
				.el-vant-bg {
					background: #f5feff;
					color: #999;
					margin: 0 8px;
					height: 64px;
					border-radius: 8px;
					padding: 10px 0px;
					font-size: 0.875rem;

					.el-current {
						padding-left: 38px;
					}
				}
			}

			.userPice {
				display: flex;
				height: 46px;
				line-height: 46px;
				margin-top: 2.5rem;
				border-top: 0.0625rem solid #ededed;
				padding-bottom: 0.75rem;
				font-size: 0.875rem;

				.userAccount {
					flex: 1;
					color: #96989d;
					text-align: left;
				}

				.userMoney {
					flex: 1;
					color: #ff8038;
					text-align: right;
				}
			}
		}

		.header {
			display: flex;
			padding: 20px;
			padding-bottom: 5px;

			.header-userInfo {
				.el-status {
					// width: 40%;
					margin-right: 6px;
					display: inline-block;
					font-size: 10px;
					line-height: 16px;
					vertical-align: middle;
				}

				.card-bg {
					padding-left: 14px;
					background: url(../../assets/home/icon01.png) no-repeat left center;
					background-size: 11px;
					height: 16px;
				}

				.auth-bg {
					padding-left: 14px;
					background: url(../../assets/home/icon02.png) no-repeat left center;
					background-size: 12px 10px;
					height: 16px;
				}

				.phone-bg {
					padding-left: 14px;
					background: url(../../assets/home/phone.png) no-repeat left center;
					background-size: 11px;
					height: 16px;
				}
			}

			.logo {
				width: 52px;
				height: 52px;
				margin-right: 10px;

				img {
					width: 52px;
					height: 52px;
					margin-bottom: 10px;
					border-radius: 35px;
					border: 2px solid #fff;
				}
			}

			.refresh {
				flex: 0.7;
				text-align: end;
				position: absolute;
				right: 10px;

				span {
					display: inline-block;
					vertical-align: middle;
					width: 24px;
				}

				.freshBtn {
					display: flex;
					position: relative;
					width: 30px;
					height: 24px;
					padding: 10px;
					border: none;

					img {
						position: absolute;
						top: 2px;
						left: 3px;
						width: 20px;
						height: 18px;
					}
				}
			}

			.header-userInfo {
				width: 100%;
				flex: 2;
				padding-top: 8px;

				p {
					line-height: 24px;
					font-size: 16px;
				}

				>div {
					display: flex;

					p {
						flex: 1;
					}

					p:last-child {
						text-align: right;
					}
				}

				.iccid-line {
					display: inline-block;
					font-size: 16px;
					margin-bottom: 5px;
					width: 100%;

					div,
					p {
						display: inline-block;
						vertical-align: middle;
					}

					div {
						margin-left: 3px;
					}
				}
			}
		}
	}

	.flowInfo {
		height: 1.875rem;
		display: flex;
		margin-top: 0.875rem;

		.flowInfo_left {
			flex: 1;
			text-align: center;

			.flowInfo_1 {
				color: #a2a2a2;
				font-size: 0.875rem;
			}

			.flowInfo_content {
				font-size: 1.375rem;
				color: #333333;
				margin-bottom: 0.625rem;
				font-family: HarmonyOS_Sans_SC_Bold;
			}
		}
	}

	.vant-notice {
		.van-icon-volume-o {
			color: #ff8038;
		}
	}

	.iccid-list {
		padding: 30px 15px 10px;
		box-sizing: border-box;

		h1 {
			font-weight: bold;
			text-align: center;
			margin-bottom: 10px;
		}

		.iccid-list-item {
			box-sizing: border-box;
			height: 45px;
			display: flex;
			margin-bottom: 2px;
			border-bottom: 1px solid #f7f7f7;

			p {
				flex: 1;
				line-height: 45px;
				color: #000;
			}

			button {
				margin: 2px 0 0 5px;
				height: 40px;
				width: 70px;
				color: #909399;
				background: #f4f4f5;
				border: 1px solid #d3d4d6;
				border-radius: 5px;
			}

			.delete-item {
				color: #f56c6c;
				background: #fef0f0;
				border: 1px solid #fbc4c4;
				border-radius: 5px;
			}
		}
	}

	.main {
		top: 240px;
		left: 0;
		margin-top: 13rem;

		.content-top {
			width: 100%;

			.main-top {
				padding: 5px 10px;
				margin-bottom: 10px;
				background: #fff;

				.first-line {
					flex-wrap: wrap;

					p.packageName {
						width: 100%;
						border-bottom: 1px solid #e7e7e7;

						span {
							div {
								flex: 1;
								color: #333;
								text-align: right;
								font-size: 0.9375rem;
							}

							div:first-child {
								color: #96989d;
								text-align: left;
							}
						}

						a {
							color: rgb(25, 137, 250);
						}
					}

					p.morePackage {
						max-width: 40px;
						text-align: right;

						a {
							color: rgb(25, 137, 250);
						}
					}

					p.time-line {
						width: 100%;

						div {
							flex: 1;
							color: #333;
							text-align: right;
							font-size: 0.9375rem;
						}

						div:first-child {
							color: #96989d;
							text-align: left;
						}
					}
				}

				.line {
					display: flex;
					margin: 0;
					padding: 0 0 5px 0;
					font-size: 0.8rem;

					p {
						margin: 0;
						height: 40px;
						line-height: 40px;
					}

					>div {
						display: flex;
						flex: 0;
						flex-direction: row-reverse;

						span {
							display: flex;
							height: 24px;
							line-height: 24px;
							text-align: right;
							max-width: 200px;
							color: #ffa941;
							font-weight: bold;
							margin-right: 5px;
						}

						.rechargeBtn {
							width: 50px;
							height: 28px;
							margin-left: 10px;
							color: #fff;
							border-radius: 3px;
							border: none;
							background: #ffaa43;
						}
					}

					.p-sim {
						width: 100%;

						div {
							flex: 1;
							color: #fff;
							text-align: right;
							font-size: 0.9375rem;
						}

						div:first-child {
							color: #96989d;
							text-align: left;
						}
					}
				}
			}
		}

		.content-bottom {
			width: 100%;
			padding-top: 0;

			.main-bottom {
				padding: 0 0 70px 0;
				background: #fff;
				width: 94%;
				margin: 0 auto;
				box-shadow: 0px 3px 11px 0px rgba(193, 193, 193, 0.51);
				border-radius: 10px;

				>div {
					display: flex;
					flex-wrap: wrap;

					>div {
						width: 25%;
						display: flex;
						margin-top: 25px;
						text-align: center;

						>a {
							width: 100%;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;

							img {
								width: 28%;
							}

							>div {
								width: 20%;
								height: 1px;
								margin-bottom: 12px;
							}

							span {
								font-size: 0.75rem;
								color: #333333;
							}
						}
					}
				}
			}
		}
	}

	.tip {
		line-height: 24px;
		margin: 0 20px;
		padding: 10px;
		color: #c34e4e;
		background: #ffe1e1;
		border-radius: 5px;
		text-align: center;
	}

	.footer {
		display: flex;
		height: 26%;
		padding: 0 10%;
		align-items: center;
		justify-content: center;
	}

	.pkgList {
		padding: 10px 20px;

		h3 {
			margin-top: 20px;
			font-size: 14px;
			line-height: 28px;
			font-weight: bold;
		}

		ul {
			line-height: 38px;

			li {
				display: flex;
				justify-content: space-between;
				margin-bottom: 15px;

				>p {
					display: flex;
					align-items: center;
				}

				>div {
					p {
						line-height: 18px;
						font-size: 12px;
					}
				}
			}
		}
	}
}

.red-defind {
	color: #cc2b2b;
}

.green-defind {
	color: green;
}

.changePasswordPanel {
	padding: 10px;

	.icon-cross {
		position: absolute;
		right: 10px;
		font-size: 16px;
	}

	p {
		margin: 10px 16px 0 16px;
		line-height: 30px;
	}

	.confirmChangePassword {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;

		.confirmChangePasswordBtn {
			width: 80px;
			margin: 0 15px;
		}
	}
}

.home-advertisement {
	margin-top: 100px;
}

.analysisHandlerDialog {
	p {
		font-size: 0.9rem;
		line-height: 1.5rem;
		padding: 0 1rem;

		span {
			font-weight: bold;
		}

		a:after {
			display: block;
			content: "clear";
			height: 0;
			clear: both;
			overflow: hidden;
			visibility: hidden;
		}
	}

	p:first-child {
		padding-top: 0.5rem;
	}
}

.signOut {
	background: #efefef;
	text-align: center;
	// margin: 10px 0;
	height: 40px;
	line-height: 40px;
	font-size: 16px;
	position: fixed;
	width: 100%;
	bottom: 0;
}

.tag-read {
	font-family: inherit;
	font-size: 100%;
	line-height: 1.15;
	margin: 0;
	background-color: black;
	background: black;
}

.sdaf {
	height: 46px;
	background: #f2f2f2;
	display: flex;
	border-top-right-radius: 20px;
	border-top-left-radius: 20px;

	.flow-btn {
		color: #050505;
		font-size: 16px;
		text-align: center;
		line-height: 46px;
		font-weight: 500;
		position: relative;
		width: 50%;

		span {
			position: relative;
			font-family: HarmonyOS_Sans_SC_Bold;
			z-index: 1;
			font-weight: 600;
		}
	}

	.flow-btn.active {
		div {
			position: absolute;
			background: url(../../assets/home/btn02.png) no-repeat left center;
			background-size: 174px 52px;
			top: -9px;
			width: 100%;
			height: 59px;
		}
	}

	.flow-btn.active1 {
		div {
			position: absolute;
			background: url(../../assets/home/btn01.png) no-repeat left center;
			background-size: 100%;
			top: -9px;
			width: 100%;
			height: 59px;
		}
	}
}
</style>

<style>
.changePasswordPanel [class*="van-hairline"]::after {
	border-color: #c4cedc;
}
</style>
